export default __webpack_public_path__ + "d118a13fcc8452cfbf09c0b1635e1e1a.jpeg";